"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserStorageFacade = void 0;
var PREFIX = "stellarkeys";
/**
 * Facade for `BrowserStorageKeyStore` encapsulating the access to the actual
 * browser storage
 */
var BrowserStorageFacade = /** @class */ (function () {
    function BrowserStorageFacade() {
        this.storage = null;
        this.prefix = PREFIX;
    }
    BrowserStorageFacade.prototype.configure = function (params) {
        Object.assign(this, params);
    };
    BrowserStorageFacade.prototype.hasKey = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.check();
                        if (!(this.storage !== null)) return [3 /*break*/, 2];
                        _c = (_b = Object).keys;
                        return [4 /*yield*/, this.storage.get("".concat(this.prefix, ":").concat(id))];
                    case 1:
                        _a = !!_c.apply(_b, [_d.sent()]).length;
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _d.label = 3;
                    case 3: return [2 /*return*/, _a];
                }
            });
        });
    };
    BrowserStorageFacade.prototype.getKey = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var key, itemObj, _a, item;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.check();
                        key = "".concat(this.prefix, ":").concat(id);
                        if (!(this.storage !== null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.storage.get(key)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        itemObj = _a;
                        item = itemObj[key];
                        return [2 /*return*/, item || null];
                }
            });
        });
    };
    BrowserStorageFacade.prototype.setKey = function (id, key) {
        var _a;
        this.check();
        return this.storage !== null
            ? this.storage.set((_a = {}, _a["".concat(this.prefix, ":").concat(id)] = __assign({}, key), _a))
            : null;
    };
    BrowserStorageFacade.prototype.removeKey = function (id) {
        this.check();
        return this.storage !== null
            ? this.storage.remove("".concat(this.prefix, ":").concat(id))
            : null;
    };
    BrowserStorageFacade.prototype.getAllKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var regexp, keys, storageObj, storageKeys, _i, storageKeys_1, storageKey, raw_id, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.check();
                        regexp = RegExp("^".concat(PREFIX, "\\:(.*)"));
                        keys = [];
                        if (!(this.storage !== null)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.storage.get(null)];
                    case 1:
                        storageObj = _a.sent();
                        storageKeys = Object.keys(storageObj);
                        _i = 0, storageKeys_1 = storageKeys;
                        _a.label = 2;
                    case 2:
                        if (!(_i < storageKeys_1.length)) return [3 /*break*/, 5];
                        storageKey = storageKeys_1[_i];
                        raw_id = storageKey;
                        if (!(raw_id !== null && regexp.test(raw_id))) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getKey(regexp.exec(raw_id)[1])];
                    case 3:
                        key = _a.sent();
                        if (key !== null) {
                            keys.push(key);
                        }
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, keys];
                }
            });
        });
    };
    BrowserStorageFacade.prototype.check = function () {
        if (this.storage === null) {
            throw new Error("A storage object must have been set");
        }
        if (this.prefix === "") {
            throw new Error("A non-empty prefix must have been set");
        }
        return this.storage !== null && this.prefix !== "";
    };
    return BrowserStorageFacade;
}());
exports.BrowserStorageFacade = BrowserStorageFacade;
